"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("infiniTableConfigManager", function () {
  var stateManager = null;
  return {
    /**
     * 
     * @param provider
     */
    setTableStateManager: function setTableStateManager(provider) {
      stateManager = provider;
    },
    getTableStateManager: function getTableStateManager() {
      return stateManager;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/infiniTableConfigManager.js
// module id = 2810
// module chunks = 13